/* ============================================================
   Hanger Uniforms — Design Studio
   Self-contained, dependency-free product customizer.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Garment mockups (inline SVG, tintable) ---------- */
  function shade(hex, pct) {
    var n = parseInt(hex.slice(1), 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    r = Math.round(r + (pct < 0 ? r : 255 - r) * pct);
    g = Math.round(g + (pct < 0 ? g : 255 - g) * pct);
    b = Math.round(b + (pct < 0 ? b : 255 - b) * pct);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  function garmentSVG(type, view, color) {
    var dark = shade(color, -0.18), line = shade(color, -0.32);
    var body;
    if (type === 'hoodie') {
      body = view === 'back'
        ? '<path d="M150 90 L100 130 L70 250 L120 270 L120 470 L280 470 L280 270 L330 250 L300 130 L250 90 Q200 120 150 90Z" fill="'+color+'" stroke="'+line+'" stroke-width="3"/>'
          + '<path d="M150 90 Q200 140 250 90 L250 70 L150 70Z" fill="'+dark+'" stroke="'+line+'" stroke-width="3"/>'
        : '<path d="M150 90 L100 130 L70 250 L120 270 L120 470 L280 470 L280 270 L330 250 L300 130 L250 90 Q200 120 150 90Z" fill="'+color+'" stroke="'+line+'" stroke-width="3"/>'
          + '<path d="M150 90 Q200 150 250 90 L250 200 Q200 230 150 200Z" fill="'+dark+'" stroke="'+line+'" stroke-width="3"/>'
          + '<path d="M170 250 L170 400 M230 250 L230 400" stroke="'+line+'" stroke-width="2" fill="none"/>';
    } else if (type === 'tank') {
      body = '<path d="M160 80 L120 110 L110 200 L140 210 L140 470 L260 470 L260 210 L290 200 L280 110 L240 80 Q235 130 200 130 Q165 130 160 80Z" fill="'+color+'" stroke="'+line+'" stroke-width="3"/>';
    } else if (type === 'longsleeve') {
      body = '<path d="M150 85 L95 115 L55 300 L100 320 L120 280 L120 470 L280 470 L280 280 L300 320 L345 300 L305 115 L250 85 Q200 120 150 85Z" fill="'+color+'" stroke="'+line+'" stroke-width="3"/>'
        + (view === 'back' ? '' : '<path d="M150 85 Q200 130 250 85 L250 105 L150 105Z" fill="'+dark+'" stroke="'+line+'" stroke-width="3"/>');
    } else if (type === 'polo') {
      body = '<path d="M150 90 L105 120 L75 240 L120 260 L120 470 L280 470 L280 260 L325 240 L295 120 L250 90 Q200 120 150 90Z" fill="'+color+'" stroke="'+line+'" stroke-width="3"/>';
      if (view !== 'back') {
        body += '<path d="M175 95 L200 150 L225 95 L215 88 L200 120 L185 88Z" fill="'+dark+'" stroke="'+line+'" stroke-width="2"/>'
          + '<path d="M195 130 L195 200 L205 200 L205 130" stroke="'+line+'" stroke-width="2" fill="none"/>';
      }
    } else { /* tee */
      body = '<path d="M150 85 L100 115 L65 210 L110 235 L120 245 L120 470 L280 470 L280 245 L290 235 L335 210 L300 115 L250 85 Q200 120 150 85Z" fill="'+color+'" stroke="'+line+'" stroke-width="3"/>'
        + (view === 'back'
            ? '<path d="M155 85 Q200 110 245 85 L245 98 L155 98Z" fill="'+dark+'" stroke="'+line+'" stroke-width="2"/>'
            : '<path d="M150 85 Q200 135 250 85 L245 78 Q200 118 155 78Z" fill="'+dark+'" stroke="'+line+'" stroke-width="2"/>');
    }
    return '<svg viewBox="0 0 400 500" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">'
      + '<defs><filter id="sh" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="6" stdDeviation="8" flood-color="rgba(0,0,0,0.12)"/></filter></defs>'
      + '<g filter="url(#sh)">' + body + '</g></svg>';
  }

  /* ---------- Print-area rectangles (% of stage: x,y,w,h) ---------- */
  var PRINT_AREAS = {
    'front':      { view: 'front', rect: [34, 30, 32, 34] },
    'leftchest':  { view: 'front', rect: [52, 27, 15, 13] },
    'back':       { view: 'back',  rect: [33, 26, 34, 40] },
    'leftsleeve': { view: 'front', rect: [17, 30, 12, 12] },
    'rightsleeve':{ view: 'front', rect: [71, 30, 12, 12] }
  };
  var LOCATIONS = [
    { id: 'front', label: 'Front Center' },
    { id: 'leftchest', label: 'Left Chest' },
    { id: 'back', label: 'Full Back' },
    { id: 'leftsleeve', label: 'Left Sleeve' },
    { id: 'rightsleeve', label: 'Right Sleeve' }
  ];

  function init(root) {
    var stage = root.querySelector('[data-stage]');
    var garmentImg = root.querySelector('[data-garment-img]');
    var printArea = root.querySelector('[data-printarea]');
    var tabsWrap = root.querySelector('[data-tabs]');
    var colorsWrap = root.querySelector('[data-colors]');
    var colorName = root.querySelector('[data-color-name]');
    var garmentsWrap = root.querySelector('[data-garments]');
    var fileInput = root.querySelector('[data-file]');
    var textBar = root.querySelector('[data-textbar]');
    var textInput = root.querySelector('[data-text-input]');
    var fontSelect = root.querySelector('[data-font]');
    var textColor = root.querySelector('[data-text-color]');
    var sizesWrap = root.querySelector('[data-sizes]');
    var methodSelect = root.querySelector('[data-method]');
    var toast = root.querySelector('[data-toast]');

    var COLORS = JSON.parse(root.getAttribute('data-colors-json') || '[]');
    var GARMENTS = JSON.parse(root.getAttribute('data-garments-json') || '[]');
    var PRICES = JSON.parse(root.getAttribute('data-prices-json') || '{}');
    var variantId = root.getAttribute('data-variant-id') || '';
    var quoteUrl = root.getAttribute('data-quote-url') || '/pages/request-a-quote';
    // Product mode: use the real product photo(s) as the base instead of SVG garments
    var PRODUCT_IMAGE = root.getAttribute('data-product-image') || '';
    var PRODUCT_BACK = root.getAttribute('data-product-back-image') || '';
    var IS_PRODUCT = !!PRODUCT_IMAGE || COLORS.some(function (c) { return c.image; });

    var state = {
      garment: GARMENTS[0] ? GARMENTS[0].id : 'tee',
      color: COLORS[0] ? COLORS[0].hex : '#1f2937',
      colorLabel: COLORS[0] ? COLORS[0].name : 'Black',
      colorImage: COLORS[0] ? (COLORS[0].image || '') : '',
      colorBack: COLORS[0] ? (COLORS[0].back || '') : '',
      location: 'front',
      designs: {},          // location -> [elements]
      selected: null,
      counter: 0
    };
    LOCATIONS.forEach(function (l) { state.designs[l.id] = []; });

    /* ----- rendering ----- */
    function currentGarment() { return GARMENTS.filter(function (g) { return g.id === state.garment; })[0]; }
    function baseImageFor(view) {
      if (IS_PRODUCT) {
        if (view === 'back') return state.colorBack || PRODUCT_BACK || state.colorImage || PRODUCT_IMAGE;
        return state.colorImage || PRODUCT_IMAGE;
      }
      // Generic studio: a garment may carry uploaded photo(s) instead of the SVG
      var g = currentGarment();
      if (g && g.image) return (view === 'back' && g.back) ? g.back : g.image;
      return '';
    }
    function renderGarment() {
      var view = PRINT_AREAS[state.location].view;
      var src = baseImageFor(view);
      if (src) {
        garmentImg.innerHTML = '<img class="studio__base-img" src="' + src + '" alt="' + escapeHtml(state.colorLabel) + '">';
      } else {
        garmentImg.innerHTML = garmentSVG(state.garment, view, state.color);
      }
    }
    // Print-area rect for a location — a garment photo can override front/back
    function areaFor(loc) {
      var pa = PRINT_AREAS[loc];
      if (!IS_PRODUCT) {
        var g = currentGarment();
        if (g && g.areas) {
          var a = pa.view === 'back' ? g.areas.back : g.areas.front;
          if (a && a.length === 4) return a;
        }
      }
      return pa.rect;
    }
    function renderPrintArea() {
      var r = areaFor(state.location);
      printArea.style.left = r[0] + '%';
      printArea.style.top = r[1] + '%';
      printArea.style.width = r[2] + '%';
      printArea.style.height = r[3] + '%';
    }
    function renderElements() {
      // remove existing element nodes
      Array.prototype.slice.call(stage.querySelectorAll('[data-el]')).forEach(function (n) { n.remove(); });
      (state.designs[state.location] || []).forEach(function (el) {
        stage.appendChild(buildEl(el));
      });
      updateSummary();
    }
    function buildEl(el) {
      var node = document.createElement('div');
      node.className = 'studio__el' + (state.selected === el.id ? ' is-selected' : '');
      node.setAttribute('data-el', el.id);
      node.style.left = el.x + '%';
      node.style.top = el.y + '%';
      node.style.width = el.w + '%';
      node.style.height = el.h + '%';
      node.style.transform = 'rotate(' + el.rot + 'deg)';
      if (el.type === 'image') {
        node.innerHTML = '<img src="' + el.src + '" alt="artwork">';
      } else {
        node.innerHTML = '<span class="studio__el-text" style="color:' + el.color + ';font-family:' + el.font + ';font-size:' + el.size + 'px;">' + escapeHtml(el.text) + '</span>';
        node.style.height = 'auto';
      }
      node.insertAdjacentHTML('beforeend',
        '<span class="studio__handle studio__handle--rotate" data-h="rotate"></span>' +
        '<span class="studio__handle studio__handle--resize" data-h="resize"></span>' +
        '<span class="studio__handle studio__handle--delete" data-h="delete">×</span>');
      attachInteract(node, el);
      return node;
    }

    /* ----- selection ----- */
    function select(id) { state.selected = id; renderElements(); syncTextBar(); }
    function deselect() { if (state.selected) { state.selected = null; renderElements(); textBar.classList.remove('is-open'); } }

    /* ----- interactions (drag / resize / rotate) ----- */
    function attachInteract(node, el) {
      node.addEventListener('pointerdown', function (e) {
        if (e.target.getAttribute('data-h')) return;
        e.preventDefault();
        select(el.id);
        var rect = stage.getBoundingClientRect();
        var startX = e.clientX, startY = e.clientY, ox = el.x, oy = el.y;
        function move(ev) {
          el.x = clamp(ox + (ev.clientX - startX) / rect.width * 100, -5, 95);
          el.y = clamp(oy + (ev.clientY - startY) / rect.height * 100, -5, 95);
          node.style.left = el.x + '%'; node.style.top = el.y + '%';
        }
        drag(move);
      });
      var rz = node.querySelector('[data-h="resize"]');
      rz.addEventListener('pointerdown', function (e) {
        e.preventDefault(); e.stopPropagation(); select(el.id);
        var rect = stage.getBoundingClientRect();
        var startX = e.clientX, ow = el.w, oh = el.h, ratio = el.h / el.w;
        function move(ev) {
          var dw = (ev.clientX - startX) / rect.width * 100;
          el.w = clamp(ow + dw, 5, 90);
          if (el.type === 'image') { el.h = el.w * ratio; node.style.height = el.h + '%'; }
          else { el.size = Math.max(8, el.size * (el.w / ow)); node.querySelector('.studio__el-text').style.fontSize = el.size + 'px'; ow = el.w; }
          node.style.width = el.w + '%';
        }
        drag(move, updateSummary);
      });
      var rot = node.querySelector('[data-h="rotate"]');
      rot.addEventListener('pointerdown', function (e) {
        e.preventDefault(); e.stopPropagation(); select(el.id);
        var box = node.getBoundingClientRect();
        var cx = box.left + box.width / 2, cy = box.top + box.height / 2;
        function move(ev) {
          el.rot = Math.round(Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI + 90);
          node.style.transform = 'rotate(' + el.rot + 'deg)';
        }
        drag(move);
      });
      node.querySelector('[data-h="delete"]').addEventListener('pointerdown', function (e) {
        e.preventDefault(); e.stopPropagation();
        var arr = state.designs[state.location];
        arr.splice(arr.indexOf(el), 1);
        state.selected = null; renderElements(); textBar.classList.remove('is-open');
      });
    }
    function drag(onMove, onEnd) {
      function up() {
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', up);
        if (onEnd) onEnd();
      }
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', up);
    }

    /* ----- add elements ----- */
    function addImage(src) {
      var id = ++state.counter;
      var r = areaFor(state.location);
      state.designs[state.location].push({ id: id, type: 'image', src: src, x: r[0] + r[2] * 0.15, y: r[1] + r[3] * 0.15, w: r[2] * 0.7, h: r[3] * 0.7, rot: 0 });
      select(id);
    }
    function addText() {
      var id = ++state.counter;
      var r = areaFor(state.location);
      state.designs[state.location].push({ id: id, type: 'text', text: 'Your Text', x: r[0] + 2, y: r[1] + r[3] / 2, w: r[2] - 4, h: 10, rot: 0, color: '#111111', font: 'Poppins, sans-serif', size: 22 });
      select(id);
      textBar.classList.add('is-open');
      textInput.value = 'Your Text'; textInput.focus(); textInput.select();
    }
    function syncTextBar() {
      var el = current();
      if (el && el.type === 'text') {
        textBar.classList.add('is-open');
        textInput.value = el.text; fontSelect.value = el.font; textColor.value = el.color;
      } else { textBar.classList.remove('is-open'); }
    }
    function current() {
      return (state.designs[state.location] || []).filter(function (e) { return e.id === state.selected; })[0];
    }

    /* ----- tabs / colors / garments ----- */
    function buildTabs() {
      tabsWrap.innerHTML = '';
      LOCATIONS.forEach(function (l) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'studio__tab' + (l.id === state.location ? ' is-active' : '');
        b.innerHTML = l.label + (state.designs[l.id].length ? '<span class="dot"></span>' : '');
        b.addEventListener('click', function () { state.location = l.id; state.selected = null; buildTabs(); renderGarment(); renderPrintArea(); renderElements(); textBar.classList.remove('is-open'); });
        tabsWrap.appendChild(b);
      });
    }
    function buildColors() {
      if (!colorsWrap) return;
      colorsWrap.innerHTML = '';
      COLORS.forEach(function (c) {
        var active = c.image ? (c.image === state.colorImage) : (c.hex === state.color);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'studio__color' + (c.image ? ' studio__color--img' : '') + (active ? ' is-active' : '');
        if (c.image) { b.style.backgroundImage = 'url(' + c.image + ')'; }
        else { b.style.background = c.hex; }
        b.title = c.name;
        b.addEventListener('click', function () {
          state.color = c.hex || state.color; state.colorLabel = c.name;
          state.colorImage = c.image || ''; state.colorBack = c.back || '';
          colorName.textContent = c.name; buildColors(); renderGarment();
        });
        colorsWrap.appendChild(b);
      });
      colorName.textContent = state.colorLabel;
    }
    function buildGarments() {
      if (!garmentsWrap) return;
      garmentsWrap.innerHTML = '';
      GARMENTS.forEach(function (g) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'studio__garment' + (g.id === state.garment ? ' is-active' : '');
        var thumb = g.image ? '<img class="studio__garment-thumb" src="' + g.image + '" alt="">' : garmentSVG(g.id, 'front', '#c9ccd1');
        b.innerHTML = '<span data-mini>' + thumb + '</span><span>' + escapeHtml(g.label) + '</span>';
        b.addEventListener('click', function () { state.garment = g.id; buildGarments(); renderGarment(); toggleColorGroup(); updateSummary(); });
        garmentsWrap.appendChild(b);
      });
    }
    // Hide the color/tint picker when the current base is a real photo (can't be tinted)
    function toggleColorGroup() {
      var grp = root.querySelector('[data-color-group]');
      if (!grp) return;
      var photo = !!baseImageFor(PRINT_AREAS[state.location].view) && !IS_PRODUCT;
      grp.style.display = photo ? 'none' : '';
    }

    /* ----- pricing ----- */
    function totalQty() {
      var t = 0;
      sizesWrap.querySelectorAll('input').forEach(function (i) { t += parseInt(i.value, 10) || 0; });
      return t;
    }
    function decoratedLocations() {
      return LOCATIONS.filter(function (l) { return state.designs[l.id].length > 0; }).length;
    }
    function unitPrice() {
      var base = (PRICES.base && PRICES.base[state.garment]) || PRICES.default_base || 18;
      var locs = decoratedLocations();
      var deco = (PRICES.decoration_first || 6) + Math.max(0, locs - 1) * (PRICES.decoration_extra || 4);
      var qty = totalQty();
      var mult = qty >= 100 ? 0.78 : qty >= 48 ? 0.86 : qty >= 24 ? 0.93 : 1;
      return (base + (locs ? deco : 0)) * mult;
    }
    function updateSummary() {
      var qty = totalQty(), unit = unitPrice();
      root.querySelector('[data-sum-qty]').textContent = qty;
      root.querySelector('[data-sum-locs]').textContent = decoratedLocations();
      root.querySelector('[data-sum-unit]').textContent = money(unit);
      root.querySelector('[data-sum-total]').textContent = money(unit * qty);
      buildTabsDots();
    }
    function buildTabsDots() {
      tabsWrap.querySelectorAll('.studio__tab').forEach(function (b, i) {
        var has = state.designs[LOCATIONS[i].id].length > 0;
        var dot = b.querySelector('.dot');
        if (has && !dot) b.insertAdjacentHTML('beforeend', '<span class="dot"></span>');
        if (!has && dot) dot.remove();
      });
    }

    /* ----- export mockup to PNG ----- */
    function safeExport(canvas, cb) {
      try { cb(canvas.toDataURL('image/png')); }
      catch (e) { cb(null); }  // cross-origin product image tainted the canvas
    }
    function exportMockup(cb) {
      var size = 800;
      var canvas = document.createElement('canvas');
      canvas.width = size; canvas.height = size;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#f4f4f2'; ctx.fillRect(0, 0, size, size);
      var view = PRINT_AREAS[state.location].view;
      var baseSrc = baseImageFor(view);
      var gImg = new Image();
      gImg.crossOrigin = 'anonymous';
      gImg.onload = function () {
        // contain product photo; SVG garment fills the square
        if (baseSrc) {
          var r = Math.min(size / gImg.width, size / gImg.height);
          var w = gImg.width * r, h = gImg.height * r;
          ctx.drawImage(gImg, (size - w) / 2, (size - h) / 2, w, h);
        } else {
          ctx.drawImage(gImg, 0, 0, size, size);
        }
        var els = state.designs[state.location].slice();
        (function next(i) {
          if (i >= els.length) { safeExport(canvas, cb); return; }
          var el = els[i];
          var px = el.x / 100 * size, py = el.y / 100 * size, pw = el.w / 100 * size;
          if (el.type === 'image') {
            var im = new Image();
            im.onload = function () {
              var ph = pw * (im.height / im.width);
              drawRot(ctx, px + pw / 2, py + ph / 2, el.rot, function () { ctx.drawImage(im, -pw / 2, -ph / 2, pw, ph); });
              next(i + 1);
            };
            im.onerror = function () { next(i + 1); };
            im.src = el.src;
          } else {
            var fs = el.size / 500 * size * (root.querySelector('[data-stage]').offsetWidth ? (size / root.querySelector('[data-stage]').offsetWidth) : 1);
            ctx.save(); ctx.fillStyle = el.color; ctx.font = '700 ' + fs + 'px ' + el.font; ctx.textBaseline = 'top';
            drawRot(ctx, px, py, el.rot, function () { ctx.fillText(el.text, 0, 0); });
            ctx.restore(); next(i + 1);
          }
        })(0);
      };
      gImg.onerror = function () { safeExport(canvas, cb); };
      if (baseSrc) {
        gImg.src = baseSrc;
      } else {
        var svg = garmentSVG(state.garment, view, state.color);
        gImg.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
      }
    }
    function drawRot(ctx, cx, cy, deg, draw) {
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(deg * Math.PI / 180); draw(); ctx.restore();
    }

    /* ----- spec text ----- */
    function buildSpec() {
      var lines = [];
      lines.push('Product: ' + productName() + ' — ' + state.colorLabel);
      lines.push('Decoration method: ' + (methodSelect.value || 'Recommend for me'));
      var sizes = [];
      sizesWrap.querySelectorAll('input').forEach(function (i) { if ((parseInt(i.value, 10) || 0) > 0) sizes.push(i.getAttribute('data-size') + ':' + i.value); });
      lines.push('Sizes: ' + (sizes.join(', ') || '(to be confirmed)'));
      LOCATIONS.forEach(function (l) {
        var d = state.designs[l.id];
        if (!d.length) return;
        var parts = d.map(function (e) { return e.type === 'image' ? 'uploaded art' : 'text "' + e.text + '"'; });
        lines.push(l.label + ': ' + parts.join(' + '));
      });
      return lines.join('\n');
    }

    /* ----- actions ----- */
    root.querySelector('[data-action="upload"]').addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      var f = fileInput.files[0]; if (!f) return;
      if (f.type.indexOf('image/') !== 0) { showToast('Preview supports PNG/JPG/SVG. For AI/EPS/PDF, upload at checkout or email us.'); fileInput.value=''; return; }
      var reader = new FileReader();
      reader.onload = function () { addImage(reader.result); };
      reader.readAsDataURL(f); fileInput.value = '';
    });
    root.querySelector('[data-action="text"]').addEventListener('click', addText);
    root.querySelector('[data-action="clear"]').addEventListener('click', function () {
      state.designs[state.location] = []; state.selected = null; renderElements(); textBar.classList.remove('is-open'); showToast('Cleared this side');
    });
    textInput.addEventListener('input', function () { var el = current(); if (el) { el.text = textInput.value; renderElements(); } });
    fontSelect.addEventListener('change', function () { var el = current(); if (el) { el.font = fontSelect.value; renderElements(); } });
    textColor.addEventListener('input', function () { var el = current(); if (el) { el.color = textColor.value; renderElements(); } });

    stage.addEventListener('pointerdown', function (e) { if (e.target === stage || e.target === garmentImg || e.target === printArea || garmentImg.contains(e.target)) deselect(); });

    sizesWrap.addEventListener('input', updateSummary);

    root.querySelector('[data-action="download"]').addEventListener('click', function () {
      exportMockup(function (url) {
        if (!url) { showToast('Preview image can’t be saved for this product photo, but your design is recorded.'); return; }
        var a = document.createElement('a'); a.href = url; a.download = 'hanger-mockup-' + state.garment + '-' + state.location + '.png'; a.click();
        showToast('Mockup downloaded');
      });
    });

    root.querySelector('[data-action="quote"]').addEventListener('click', function () {
      if (totalQty() === 0) { showToast('Add a size quantity first'); return; }
      exportMockup(function (url) {
        try {
          localStorage.setItem('hanger_design', JSON.stringify({ spec: buildSpec(), unit: unitPrice(), qty: totalQty(), total: unitPrice() * totalQty(), mockup: url || '', when: Date.now() }));
        } catch (err) {}
        showToast('Design saved — opening quote form…');
        setTimeout(function () { window.location.href = quoteUrl + '?source=design-studio'; }, 800);
      });
    });

    var cartBtn = root.querySelector('[data-action="cart"]');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        if (!variantId) { showToast('Online checkout not configured — use Get a Quote.'); return; }
        if (totalQty() === 0) { showToast('Add a size quantity first'); return; }
        cartBtn.disabled = true; cartBtn.textContent = 'Adding…';
        exportMockup(function (url) {
          var props = { 'Product': productName() + ' / ' + state.colorLabel, 'Design spec': buildSpec() };
          if (url) props['_Mockup'] = url.slice(0, 40000);
          var fd = new FormData();
          fd.append('id', variantId);
          fd.append('quantity', String(totalQty()));
          Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () { cartBtn.disabled = false; cartBtn.textContent = 'Add to Cart'; showToast('Could not add to cart. Try Get a Quote instead.'); });
        });
      });
    }

    /* ----- helpers ----- */
    function garmentLabel(id) { var g = GARMENTS.filter(function (x) { return x.id === id; })[0]; return g ? g.label : id; }
    function productName() { return IS_PRODUCT ? (root.getAttribute('data-product-title') || 'Custom product') : garmentLabel(state.garment); }
    var toastTimer;
    function showToast(msg) { toast.textContent = msg; toast.classList.add('is-shown'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-shown'); }, 2600); }

    /* ----- boot ----- */
    buildGarments(); buildColors(); buildTabs(); renderGarment(); renderPrintArea(); renderElements(); toggleColorGroup();

    // Prefill garment from URL (?type=hoodie)
    var q = new URLSearchParams(window.location.search).get('type');
    if (q && GARMENTS.some(function (g) { return g.id === q; })) { state.garment = q; buildGarments(); renderGarment(); }
  }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-design-studio]').forEach(init);
  });
})();
